import Vue from "vue";
import { Loading, Message } from "element-ui";
let loading_switch;
import * as Sentry from "@sentry/browser";
import { sendPost } from "./request"
import { sha } from '@/utils/SHA';

export const isServer = Vue.prototype.$isServer;

/**
 * 判断是否是安卓
 */
export function isAndroid() {
  return isServer ? false : /android/.test(navigator.userAgent.toLowerCase());
}

/**
 * 判断是否是IOS
 */
export function isIOS() {
  return isServer
    ? false
    : /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}

/**
 * 返回一个范围
 * @param  {Number} num 整数
 * @param  {Number} min 最小值
 * @param  {Number} max 最大值
 * @return {Number}
 */
export function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

/**
 * 获取请求参数名对应的值
 * @param  {String} name 参数名字
 * @return {String}
 */
export function getQueryString(name) {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  const res = window.location.search.substr(1).match(reg);
  if (res !== null) return window.decodeURIComponent(res[2]);
  return "";
}

/**
 * 对日期进行格式化，
 * @param {String | Number} data   要格式化的日期
 * @param {String} format 进行格式化的模式字符串
 *     支持的模式字母有:
 *     y:年,
 *     M:年中的月份(1-12),
 *     d:月份中的天(1-31),
 *     h:小时(0-23),
 *     m:分(0-59),
 *     s:秒(0-59),
 *     S:毫秒(0-999),
 *     q:季度(1-4)
 * @return String
 */
export function dateFormat(date, format) {
  date = new Date(date);
  var map = {
    M: date.getMonth() + 1, // 月份
    d: date.getDate(), // 日
    h: date.getHours(), // 小时
    m: date.getMinutes(), // 分
    s: date.getSeconds(), // 秒
    q: Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  };
  if (format == "dd") {
    let dd = Math.floor(new Date(date).getTime() / (1000 * 60 * 60 * 24));
    if (dd <= 9) {
      dd = "0" + dd;
    }
    console.log(dd);
    return dd;
  } else if (format == "hh") {
    let hh = Math.floor(
      (new Date(date).getTime() % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    if (hh <= 9) {
      hh = "0" + hh;
    }
    return hh;
  }
  format = format.replace(/([yMdhmsqS])+/g, function(all, t) {
    var v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = "0" + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === "y") {
      return (date.getFullYear() + "").substr(4 - all.length);
    }
    return all;
  });
  return format;
}

/**
 * 设置cookie
 * @param {String} sKey cookie的名字
 * @param {String} sValue cookie的值
 * @param {Number | String | Data} vEnd cookie的过期时间
 * @param {String} sPath cookie的所在目录
 * @param {String} sDomain cookie的所在域
 * @param {Boolean} bSecure 是否开启cookie的secure属性
 * @return {Boolean}
 */
export function setCookie(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
  if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
    return false;
  }
  var sExpires = "";
  if (vEnd) {
    switch (vEnd.constructor) {
      case Number:
        sExpires =
          vEnd === Infinity
            ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT"
            : "; max-age=" + vEnd;
        break;
      case String:
        sExpires = "; expires=" + vEnd;
        break;
      case Date:
        sExpires = "; expires=" + vEnd.toUTCString();
        break;
    }
  }
  document.cookie =
    encodeURIComponent(sKey) +
    "=" +
    encodeURIComponent(sValue) +
    sExpires +
    (sDomain ? "; domain=" + sDomain : "") +
    (sPath ? "; path=" + sPath : "") +
    (bSecure ? "; secure" : "");
  return true;
}

/**
 * 获取cookie
 * @param {String} sKey 获取cookie对应的名字
 * @return {String | Object}
 */
export function getCookie(sKey) {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          "(?:(?:^|.*;)\\s*" +
            encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") +
            "\\s*\\=\\s*([^;]*).*$)|^.*$"
        ),
        "$1"
      )
    ) || null
  );
}

/**
 * 删除cookie
 * @param {String} sKey cookie的名字
 * @param {String} sPath cookie的所在目录
 * @param {String} sDomain cookie的所在域
 * @return {Boolean}
 */
export function removeCookie(sKey, sPath, sDomain) {
  if (!sKey || !hasCookie(sKey)) {
    return false;
  }
  document.cookie =
    encodeURIComponent(sKey) +
    "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" +
    (sDomain ? "; domain=" + sDomain : "") +
    (sPath ? "; path=" + sPath : "");
  return true;
}

/**
 * 判断某cookie是否存在
 * @param {String} sKey cookie的名字
 * @return {Boolean}
 */
export function hasCookie(sKey) {
  return new RegExp(
    "(?:^|;\\s*)" +
      encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") +
      "\\s*\\="
  ).test(document.cookie);
}

/**
 * 获取cookies
 */
export function cookieKeys() {
  const aKeys = document.cookie
    .replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "")
    .split(/\s*(?:\=[^;]*)?;\s*/);
  for (var nIdx = 0; nIdx < aKeys.length; nIdx++) {
    aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
  }
  return aKeys;
}
/**
 * 加载图标
 */
//开启加载
export function openLoading() {
  loading_switch = Loading.service({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(255, 255, 255, 1)"
  });
}
//关闭加载
export function closeLoading() {
  loading_switch.close();
}
/**
 * 锚点定位方法
 * anchorName: 元素id [string]
 */
export function scrollToAnchor(anchorName) {
  if (anchorName) {
    const anchorElement = document.getElementById(anchorName);
    anchorElement && anchorElement.scrollIntoView({ behavior: "smooth" });
  }
}
// 防抖
export const debounce = (fn, ms = 0) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

/**
 * 判断工会头
 */
export function unionFlag() {
  let currentUnionValue;
  const union = getQueryString("union");
  const { VUE_APP_FLAG } = process.env;
  const { hostname, pathname } = window.location;

  if (union) {
    // URI带union参数的判断是工会链接
    return union;
  } else if (/^corp/.test(pathname) && pathname.match(/union\/\w+/g)) {
    // 测试环境http://corp.m.test03.com/union/lifangfang02/user/login
    currentUnionValue = pathname.match(/union\/\w+/g)[0].split("/")[1];
  } else {
    // 正式环境http://www.dbenefit.dongfangfuli.com/bfd_pc/index?union=dbenefit&city=2
    // 测试环境http://union.testzhou.zhouweiwei.qa.psf-dev.com/
    // k8s测试环境http://www.lifangfang02.test01.com/drama_pc/home?city=145&mc=Shows
    // stage环境http://www.rjh.stage.dongfangfuli.com/shop/home?city=145&mc=Shopping
    if (
      (VUE_APP_FLAG === "test" && /^(?:union)/.test(hostname)) ||
      /^(?:w{3})\.((?!stage)[A-Za-z1-9]{1}(\w|-)+\.)(stage\.)?(\w+\.)(?=com)/.test(
        hostname
      )
    ) {
      currentUnionValue = hostname.split(".")[1];
    } else {
      currentUnionValue = "";
    }

    return currentUnionValue;
  }
}

/*
格式化日期
*/
export function formatter(date, fomtt) {
  let YYYY = date.getFullYear();
  let MM = date.getMonth() + 1;
  let DD = date.getDate();

  if (MM < 10) {
    MM = "0" + MM;
  }

  if (DD < 10) {
    DD = "0" + DD;
  }

  switch (fomtt) {
    case "YYYY-MM-DD":
      return YYYY + "-" + MM + "-" + DD;
    case "YYYY-MM":
      return YYYY + "-" + MM;
    default:
      return YYYY + "-" + MM + "-" + DD;
  }
}
//抛出提醒信息
export function getThrowInfo(mes, type) {
  Message({
    message: mes,
    type: type,
    showClose: true
  });
}
//转换身份证号码展示
export function getExchangeCard(val, dialog) {
  let strStart, strEnd, strNew;
  !dialog ? (strStart = val.slice(0, 3)) : (strStart = val.slice(0, 7));
  strEnd = val.slice(-4);
  !dialog
    ? (strNew = strStart + "*** ******** " + strEnd)
    : (strNew = strStart + " " + val.slice(7, 14) + " " + strEnd);
  return strNew;
}
//转换手机号码展示
export function getExchangeTel(val) {
  let strStart = val.slice(0, 3);
  let strMid = val.slice(3, 7);
  let strEnd = val.slice(-4);
  let strNew = strStart + " " + strMid + " " + strEnd;
  return strNew;
}
//转换收货地址手机号码展示
export function addressExchangeTel(val) {
  let strStart = val.slice(0, 3);
  let strEnd = val.slice(-4);
  let strNew = strStart + "****" + strEnd;
  return strNew;
}
//规格化价格
export function formatPrice(val, fixed) {
  !val ? (val = "0.00") : val;
  let valNum = null;
  if (!fixed) {
    val.toString().indexOf(".") != -1
      ? (valNum = val.toString().slice(0, val.toString().indexOf(".")))
      : (valNum = val);
  } else {
    val.toString().indexOf(".") != -1
      ? (valNum = val.toString().slice(val.toString().indexOf(".")))
      : (valNum = ".00");
  }
  return valNum;
}

/**
 * 对动态脚本的封装
 * @param {String} url 脚本src地址
 * @param { Function } callback 回调函数
 */

export function loadScript(url, callback) {
  let s = document.createElement("script");
  s.type = "text/javascript";
  s.charset = "utf-8";
  s.async = true;
  if (s.readyState) {
    s.onreadystatechange = function() {
      if (/complete|loaded/.test(s.readyState)) {
        s.onreadystatechange = null;
        callback && callback();
      }
    };
  } else {
    s.onload = function() {
      callback && callback();
    };
  }

  s.src = url;
  document.body.appendChild(s);
}


/**
 * gio埋点
 * @param { String } eventName // 事件名称
 * @param { Object } params // 参数
 */
export function gioClickHandle(eventName, params,type = '') {
  const now = new Date().getTime();
  let newParams = null;
  switch (type) {
  case 'cart':
    newParams = getCartGioParams(eventName, params);
    break;
  default:
    newParams = getGioParams(eventName, params,type);
    break;
  }
  try {
    // eslint-disable-next-line
    gio('track', eventName, newParams);
    const url = `https://api.growingio.com/v3/80a245b29a70c4ad/s2s/cstm?stm=${now}`;
    const postParams = [
      {
        cs1: getCookie('gr_user_id') || 'wjn',
        tm: now,
        t: 'cstm',
        n: eventName,
        var: params,
      }
    ];
    sendPost({ url, data:postParams, baseURL: false, applicationType: true });
  } catch (error) {
    console.log(error);
  }
}

export function getGioParams(eventName, params = {},type = '') {
  const now = new Date().getTime();
  const address = JSON.parse(getCookie('address')) || {};
  const url = window.parent.location.href;
  const unionF = unionFlag() || sessionStorage.getItem('dffl_union');
  let paramNew = {
    df_platform: 'pc',
    df_source: unionF ? '百福得' : '官网',
    df_prepagename: url ? url : null,
    df_userid: getCookie('unionUserId'),
    df_city: address.cityName,
  };
  switch (eventName) {
  case 'DF_pageView':
    paramNew.df_pagename = '活动页';
    paramNew.df_channle = '节日礼包';
    paramNew.df_enteractivitytime = now;
    break;
  case 'DF_elementClick':
    paramNew.df_channle = '演出';
    paramNew.df_pagename = '搜索结果页';
    if(type === 'channelGio'){
      paramNew.df_source = unionF ? '百福得' : '官网';
      paramNew.df_activitytime = farmatDate(new Date(),'yyyy.MM.dd HH:mm:ss');
      paramNew.df_cityid = ''+ address.cityId;
    }else{
      paramNew.df_activitytime = now;
    }
    break;
  }
  paramNew = Object.assign(paramNew, params);
  console.log(paramNew,'gioparamNew');
  return paramNew;
}
/** 购物车 */
export function getCartGioParams(eventName, params = {}) {
  const now = new Date().getTime();
  const address = JSON.parse(getCookie('address')) || {};
  const url = window.parent.location.href;
  const unionF = unionFlag() || sessionStorage.getItem('dffl_union');
  let paramNew = {
    df_platform: 'pc',
    df_source: unionF ? '百福得' : '官网',
    df_prepagename: url ? url : null,
    df_userid: getCookie('unionUserId'),
    df_city: address.cityName,
  };
  switch (eventName) {
  case 'DF_elementClick':
    paramNew.df_platform = 'pc';
    paramNew.df_pagename = '购物车';
    paramNew.df_cityid = '' + address.cityId;
    break;
  }
  paramNew = Object.assign(paramNew, params);
  console.log(paramNew, 'gioparamNew');
  return paramNew;
}

/**
 * 获取频道name
 * @param { number } channelId  // 频道ID
 * @return { String }  频道name
 */
export function getChannelName(channelId) {
  let id = Number(channelId);
  switch (id) {
    case 1:
      return "电影";
      break;
    case 2:
      return "优选生活";
      break;
    case 3:
      return "生日汇";
      break;
    case 4:
      return "门票";
      break;
    case 5:
      return "演出";
      break;
    case 6:
      return "运动健身";
      break;
    case 7:
      return "400预定";
      break;
    case 8:
      return "节日礼包";
      break;
    case 9:
      return "特卖会";
      break;
    case 10:
      return "工会活动";
      break;
    case 16:
      return "京东优选";
      break;
    case 17:
      return "东福超市";
      break;
    case 18:
      return "图书";
      break;
    case 20:
      return "小米有品";
      break;
    case 22:
      return "网易严选";
      break;
    case 998:
      return "图书";
      break;
    case 999:
      return "京东优选";
      break;
    default:
      return "优选生活";
      break;
  }
}

/**
 * 时间格式化
 * @param { date } date // 时间
 * @param { string } fmt  // 格式化格式
 * @return { String }  提示文案
 */
export function farmatDate(date, fmt) {
  const o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "H+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds(),
  };
  let year = date.getFullYear().toString();
  year = year.length >= 4 ? year : "0000".substr(0, 4 - year.length) + year;

  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (year + "").substr(4 - RegExp.$1.length));
  for (const k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

/**
 * 日期格式化
 * @param { date } date // 日期
 * @return { string } fmtDate  // 格式化日期
 */
export function formatDay(date) {
  let fmtDate = '';
  let mm = date.getMonth() + 1;
  let dd = date.getDate();
  let year = date.getFullYear();
  if (year != new Date().getFullYear()) {
    fmtDate = year + '年' + mm + '月' + dd + '日';
  } else {
    fmtDate = mm + '月' + dd + '日';
  }
  return fmtDate;
}

export function isMiniprogram() {
  return window.__wxjs_environment === 'miniprogram';
}

/**
 * 错误收集器
 * @param key 标记
 * @param errorMessage 错误信息
 */
 const { NODE_ENV } = process.env;
 export function errorLog(page, key, errorMessage) {
  try {
    if (NODE_ENV === "production") {
      const error = {
        page: page, error: `error - [${key}]`,
        data: errorMessage,
        timelog: new Date().toJSON(),
        cookies: document.cookie,
        localStorage: localStorage,
        sessionStorage: sessionStorage
      };
      Sentry.withScope((scope) => {
        scope.setExtras(error);
        const eventId = Sentry.captureException(error);
      });
    }
  } catch (e) {
    console.log('error', e);
  }
}

/**
 * 构造会员中心权益接口所需入参
 */
export function getUserCenterParams(params = {}) {
  const secretKey = 'TQaXTvES';
  const _union = unionFlag() || sessionStorage.getItem('dffl_union');
  const _body = {
    sourceSys: _union ? 4 : 1, // 官网1，百福得4
    sourceWay: 2,
    ...params,
  };
  if (_union) {
    _body.union = _union;
  }
  let _params = {
    appId: this.appCode,
    msgId: "4ac05cd2-1ee2-409a-8f44-517bb10faadf",
    timestamp: +new Date(),
    version: '1.0.1',
    body: JSON.stringify({..._body}),
    sign: '',
  };
  _params.sign = sha(this.appSecret + _params.body + this.appSecret);
  return _params;
}



export const getCityName = () => {
  try {
    const address =  JSON.parse(getCookie('address')) || {}
    return sessionStorage.getItem('dram_pc_cityName') || address.name || '上海'
  } catch (error) {
    console.error(error)
    return ''
  }
}